window.addEventListener('load', (event) => {
    for (let item of document.querySelectorAll("#accordionExample .additional-item")) {
        item
            .querySelector(".item-header")
            .addEventListener("click", function () {
                if (
                    item
                    .querySelector(".accordion-collapse")
                    .classList.contains("show")
                ) {
                    item
                        .querySelector(".accordion-collapse")
                        .classList.remove("show");
                } else {

                    item.querySelector(".accordion-collapse").classList.add("show");
                } //wait 2 seconds
            });
    }


    for (let item of document.querySelectorAll(".accordion-item")) {
        item
            .querySelector(".accordion-header")
            .addEventListener("click", function () {
                if (
                    item
                    .querySelector(".accordion-collapse")
                    .classList.contains("show")
                ) {
                    item
                        .querySelector(".accordion-collapse")
                        .classList.remove("show");
                } else {
                    for (let myItem of document.querySelectorAll(
                            ".accordion-item"
                        )) {
                        myItem
                            .querySelector(".accordion-collapse")
                            .classList.remove("show");
                    }
                    item.querySelector(".accordion-collapse").classList.add("show");
                } //wait 2 seconds
            });


    }
  /*añadido davó    */

    for (let item of document.querySelectorAll(".accordion-item")) {
        item
            .querySelector(".accordion-header")
            .addEventListener("click", function () {
                if (
                    item
                    .querySelector(".accordion-button")
                    .classList.contains("show")
                ) {
                    item
                        .querySelector(".accordion-button")
                        .classList.remove("show");
                } else {
                    for (let myItem of document.querySelectorAll(
                            ".accordion-item"
                        )) {
                        myItem
                            .querySelector(".accordion-button")
                            .classList.remove("show");
                    }
                    item.querySelector(".accordion-button").classList.add("show");
                } //wait 2 seconds
            });


    }

for (let item of document.querySelectorAll("#accordionExample .additional-item")) {
    item.querySelector(".item-header").addEventListener("click", function () 
    {
        if (item.querySelector(".item-header.d-flex.align-items-center.justify-content-between").classList.contains("show")) 
        {
            item.querySelector(".item-header.d-flex.align-items-center.justify-content-between").classList.remove("show");
        } else 
        {
            item.querySelector(".item-header.d-flex.align-items-center.justify-content-between").classList.add("show");
        } //wait 2 seconds
    });
}

  
//FIN DAVO
  
    /*
      let dcl = document.getElementById("downClick")
      if(dcl){
    		dcl.addEventListener("click", function dcl(){
            document.querySelector('.color_wrapper').scrollLeft += 350;
        })
    	}
     */
});






let selectElement = document.getElementById('filter-input')

if (selectElement) {
    selectElement.addEventListener('keyup', () => {
        let allElement = document.querySelectorAll(".colorfill:not(.hidecolorfill)")
        for (let i = 0; i < allElement.length; i++) {
            let select = allElement[i].querySelector('.color-meta-title')
            let text = select.innerText.trim();
            console.log(selectElement.value.toLowerCase(), text.toLowerCase(), text.toLowerCase().includes(`${selectElement.value.toLowerCase()}`))

            let result = text.toLowerCase().includes(`${selectElement.value.toLowerCase()}`);
            if (result == false) {
             allElement[i].style.setProperty('display', 'none', 'important');
            } else {
             allElement[i].style.setProperty('display', 'inline-block', 'important')          }
        }
    });

}






var scrolled = 0;

$(document).ready(function () {

    /*  	
    $("#downClick").on("click" ,function(){
                scrolled=scrolled+300;
        
				$(".cover").animate({
				        scrollTop:  scrolled
				   });

			});

*/



});





let path = document.querySelector('path')
if (path) {
    let pathLength = path.getTotalLength()
    path.style.strokeDasharray = pathLength + '' + pathLength;
    path.style.strokeDashoffset = pathLength;

    window.addEventListener('scroll', () => {


        //what % down is it?
        var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

        //Length to offset the strokeDashoffse
        var drawLength = pathLength * scrollPercentage;

        //Draw in reverse

        path.style.strokeDashoffset = pathLength - drawLength;


    })


}



function filter() {
    console.log('filtered')
    var allFilters = '';
    var $activeFilters = $('.filter_checkbox:checked');

    var activeFiltersCount = $activeFilters.length;
    var lastActiveFilterIndex = activeFiltersCount - 1;
    let url = ''
    $activeFilters.each(function (index) {
        var filterValue = $(this).val(); // the tag
        var filterName = $(this).attr("name");
        let filterItemStr = filterName + '=' + filterValue
        if (url) {
            url = url + '&' + filterItemStr
        } else {
            url = filterItemStr
        }
        //     allFilters += filterValue; // append the tag to our filters
        //     console.log(filterValue)
    });
    url = url.replace(' ', '+')
    console.log(url)
    // Append filters to the base URL and redirect the user to the new URL
    if (url) {


        var newUrl = window.location.pathname + '?' + url;
        window.location = newUrl;
    }
}









$("#downClick").click(function () {
    $(".color_wrapper").addClass("expandhobe");
    $("#downClick").addClass("d-none");
    $(".left-s-icon #upClick").removeClass("d-none");

});
$("#upClick").click(function () {
    $(".color_wrapper").removeClass("expandhobe");
    $("#downClick").removeClass("d-none");
    $(".left-s-icon #upClick").addClass("d-none");

});







$("#downClickr").click(function () {
    $(".color_wrapper").addClass("expandhobe");
    $("#downClickr").addClass("d-none");
    $(".left-s-icon #upClickr").removeClass("d-none");

});
$("#upClickr").click(function () {
    $(".color_wrapper").removeClass("expandhobe");
    $("#downClickr").removeClass("d-none");
    $(".left-s-icon #upClickr").addClass("d-none");

});
